import { render } from "./ProspectsManager.vue?vue&type=template&id=00b3877b&scoped=true"
import script from "./ProspectsManager.vue?vue&type=script&lang=js"
export * from "./ProspectsManager.vue?vue&type=script&lang=js"

import "./ProspectsManager.vue?vue&type=style&index=0&id=00b3877b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b3877b"]])

export default __exports__